export const WIN_MESSAGES = [
    'huḥtakšiʔaƛeʔic!',
    'ʕac̓ikšiʔaƛʔick!',
    'ʕac̓ikšiʔaƛʔic!',
    'ʕac̓ikšaʔƛic!',
]
